$( ->
  if $('.cp-select2').length > 0
    $('.cp-select2').select2({
      theme: "bootstrap"
    })
)
